import { formatApiDateRangeDisplay } from '#/utils/date';

/**
 * UI range DatePicker ↔ listQuery.filters（API：`scheduled_start_date_from`／`scheduled_start_date_to`）。
 */
export function readScheduledStartDateRangeFilter(filters = {}) {
  const from = filters.scheduledStartDateFrom;
  const to = filters.scheduledStartDateTo;

  if (!from && !to) {
    return undefined;
  }

  return {
    from: from ?? '',
    to: to ?? from ?? '',
  };
}

export function applyScheduledStartDateRangeToFilters(filters = {}, range) {
  const next = { ...filters };

  if (!range?.from && !range?.to) {
    delete next.scheduledStartDateFrom;
    delete next.scheduledStartDateTo;
    return next;
  }

  const from = range.from;
  const to = range.to || range.from;

  next.scheduledStartDateFrom = from || undefined;
  next.scheduledStartDateTo = to || undefined;

  return next;
}

export function resolveScheduledStartDateFilterChipDisplay(_values, ctx = {}) {
  const display = formatApiDateRangeDisplay({
    from: ctx.filters?.scheduledStartDateFrom,
    to: ctx.filters?.scheduledStartDateTo,
  });

  return display ? [display] : [];
}
